import { get, del, postJson, putJson } from "./AXIOS";
import { POLICY } from "./CONSTANTS";

// GET - Read policy emerging outcomes
export const getPolicyEmergingOutcomes = (policyId, skip = 0, limit = 10) => {
  return get(`${POLICY}${policyId}/emerging-outcomes?skip=${skip}&limit=${limit}`);
};

// POST - Create policy emerging outcome
export const createPolicyEmergingOutcome = (policyId, outcomeData) => {
  return postJson(`${POLICY}${policyId}/emerging-outcome`, outcomeData);
};

// PUT - Update policy emerging outcome
export const updatePolicyEmergingOutcome = (policyId, emergingOutcomeId, outcomeData) => {
  return putJson(`${POLICY}${policyId}/emerging-outcome/${emergingOutcomeId}`, outcomeData);
};

// DELETE - Delete policy emerging outcome
export const deletePolicyEmergingOutcome = (policyId, emergingOutcomeId) => {
  return del(`${POLICY}${policyId}/emerging-outcome/${emergingOutcomeId}`);
}; 